<template>
  <div class="seller-offers-table-item">
    <div class="seller-offers-table-item__group">
      <div class="seller-offers-table-item__row-body-content">
        <ul class="app-table-dropdown__list seller-offers-table-item__list">
          <li class="app-table-dropdown__list-item row">
            <span class="app-table-dropdown__list-title col-6">
              Дата добавления
            </span>
            <p class="app-table-dropdown__list-text col-6">
              {{ response.createdDate | dateFormat() }}
            </p>
          </li>
          <li class="app-table-dropdown__list-item row">
            <span class="app-table-dropdown__list-title col-6">
              Плотность
            </span>
            <p class="app-table-dropdown__list-text col-6">
              {{ response.density.toFixed(3) }} кг / см3
            </p>
          </li>
          <li v-if="$development" class="app-table-dropdown__list-item row">
            <span class="app-table-dropdown__list-title col-6">
              Поставщик
            </span>
            <p class="app-table-dropdown__list-text col-6">ОйлРесурсГрупп</p>
          </li>
          <li class="app-table-dropdown__list-item row">
            <span class="app-table-dropdown__list-title col-6">
              Организация
            </span>
            <p class="app-table-dropdown__list-text col-6">
              {{ contractorName }}
            </p>
          </li>
          <li class="app-table-dropdown__list-item row">
            <span class="app-table-dropdown__list-title col-6"> Склад </span>
            <p class="app-table-dropdown__list-text col-6">
              {{ warehouseName }}
            </p>
          </li>
          <li class="app-table-dropdown__list-item row">
            <span class="app-table-dropdown__list-title col-6"> Фото </span>
            <p class="app-table-dropdown__list-text col-6">
              {{ response.hasPhoto ? 'Есть' : 'Нет' }}
            </p>
          </li>
          <li class="app-table-dropdown__list-item row">
            <span class="app-table-dropdown__list-title col-6"> Паспорт </span>
            <p class="app-table-dropdown__list-text col-6">
              {{ response.hasPassport ? 'Есть' : 'Нет' }}
            </p>
          </li>
          <li class="app-table-dropdown__list-item row">
            <span class="app-table-dropdown__list-title col-6"> Статус </span>
            <p class="app-table-dropdown__list-text col-6">
              {{ $options.STATUSES[response.status] }}
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div class="seller-offers-table-item__group">
      <table
        class="app-lots-table seller-offers-table-item__lots"
        v-if="response.lots.length"
      >
        <thead>
          <tr>
            <th></th>
            <th>Объем партии</th>
            <th>Остаток</th>
            <th>Заказано</th>
            <th>Отгружено</th>
            <th>Стоимость</th>
          </tr>
        </thead>
        <tr v-for="lot in response.lots" :key="lot.id">
          <td>
            <span class="app-lots-table__name">Лот №{{ lot.id }}</span>
          </td>
          <td>{{ lot.volume.value }} {{ perUnitText(lot.volume.unit) }}</td>
          <td>
            {{ lot.volume.value - lot.reservedValue }}
            {{ perUnitText(lot.volume.unit) }}
          </td>
          <td>{{ lot.reservedValue }}</td>
          <td>{{ lot.shippedValue }}</td>
          <td>
            {{ lot.unitPrice | price() }} руб/{{ perUnitText(lot.volume.unit) }}
          </td>
        </tr>
      </table>
    </div>

    <div class="seller-offers-table-item__row-body-bottom">
      <div class="seller-offers-table-item__row-body-btn-block">
        <app-button-control
          :route="`/offers/item/${response.id}`"
          class="seller-offers-table-item__btn"
          type="white"
          size="small"
          @click="$modal.hide('main-curtain')"
        >
          Подробнее
        </app-button-control>
        <app-button-control
          v-if="$development"
          isDisabled
          class="seller-offers-table-item__btn"
          type="white"
          size="small"
        >
          <app-svg-icon name="libra" class="seller-offer-table__icon-table" />
          Сравнить
        </app-button-control>
        <app-button-control
          v-if="$development"
          isDisabled
          class="seller-offers-table-item__btn"
          type="white"
          size="small"
        >
          <app-svg-icon
            name="bar-chart"
            class="seller-offer-table__icon-table"
          />
          Ценовая динамика
        </app-button-control>
      </div>
      <div class="seller-offers-table-item__row-body-btn-block">
        <app-button-control
          @click="togglePublished(response.id)"
          class="seller-offers-table-item__btn"
          type="white"
          size="small"
        >
          {{ publishedButtonText }}
        </app-button-control>
        <app-button-control
          v-if="$development"
          isDisabled
          class="seller-offers-table-item__btn"
          type="white"
          size="small"
        >
          Удалить
        </app-button-control>
        <app-button-control
          :route="`/offers/edit/${response.id}`"
          class="seller-offers-table-item__btn"
          type="secondary"
          size="small"
        >
          Изменить
        </app-button-control>
      </div>
    </div>
    <app-loader v-if="isLoading" isAbsolute isCircle></app-loader>
  </div>
</template>

<script>
import { perUnitText } from '@/helpers/index';
import { offersMapper } from '@/store/offers';
import { SELLER_OFFER_STATUS } from '@/helpers/enums/statuses';
import { eventBus } from '@/main';
import { nanoid } from 'nanoid';

export default {
  name: 'SellerOffersTableItem',
  components: {
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
    AppLoader: () => import('@/components/ui/AppLoader'),
  },
  props: {
    response: {
      type: Object,
      default() {
        return {};
      },
    },
    sort: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    isLoading: false,
    alertPublishConfirmEventId: nanoid(),
    alertUnpublishConfirmEventId: nanoid(),
    selectedPublishId: null,
  }),
  computed: {
    warehouseName() {
      return this.response.warehouse && this.response.warehouse.name
        ? this.response.warehouse.name
        : 'Не указан склад';
    },
    contractorName() {
      return this.response.contractor && this.response.contractor.name
        ? this.response.contractor.name
        : 'Не указан контрагент';
    },
    isPublished() {
      return (
        this.response &&
        !(
          this.response.status === 'draft' ||
          this.response.status === 'rejected'
        )
      );
    },
    publishedButtonText() {
      return this.isPublished ? 'Снять с публикации' : 'Опубликовать';
    },
  },
  created() {
    this.alertsEventListener();
    this.$options.STATUSES = SELLER_OFFER_STATUS;
  },
  methods: {
    perUnitText,

    ...offersMapper.mapActions([
      'publishSellerOffer',
      'unpublishSellerOffer',
      'getSellerOffers',
    ]),
    /**
     * Переключатель публикации офера
     * @param {Number} id
     */
    togglePublished(id) {
      this.selectedPublishId = id;
      if (this.isPublished) {
        this.unpublishOfferConfirm();
      } else {
        this.publishOfferConfirm();
      }
    },
    /**
     * Опубликовать
     */
    async publishOffer() {
      try {
        this.isLoading = true;

        await this.publishSellerOffer(this.selectedPublishId);
        this.$notify({
          group: 'success',
          type: 'success',
          title: 'Статус продукта изменен',
          text: '',
        });
        await this.getSellerOffers({ sort: this.sort });
        this.selectedPublishId = null;
      } catch {
        // -
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * Снять с публикации
     */
    async unpublishOffer() {
      try {
        this.isLoading = true;

        await this.unpublishSellerOffer(this.selectedPublishId);
        this.$notify({
          group: 'success',
          type: 'success',
          title: 'Продукт успешно снят с публикации',
          text: '',
        });
        await this.getSellerOffers({ sort: this.sort });
        this.selectedPublishId = null;
      } catch {
        // -
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * Alert - Подтверждение публикации
     */
    publishOfferConfirm() {
      this.$modal.show('alert-modal', {
        isConfirm: true,
        text: 'опубликовать предложение?',
        eventId: this.alertPublishConfirmEventId,
      });
    },
    /**
     * Alert - Подтверждение снятия с публикации
     */
    unpublishOfferConfirm() {
      this.$modal.show('alert-modal', {
        isConfirm: true,
        text: 'снять с публикации?',
        eventId: this.alertUnpublishConfirmEventId,
      });
    },
    /**
     * Слушатель событий на Alert confirm
     */
    alertsEventListener() {
      eventBus.$on('am-accept', async (data) => {
        if (data.eventId === this.alertPublishConfirmEventId) {
          await this.publishOffer();
        }

        if (data.eventId === this.alertUnpublishConfirmEventId) {
          await this.unpublishOffer();
        }
      });
    },
  },
};
</script>

<style lang="scss">
.seller-offers-table-item {
  position: relative;

  &__lots {
    margin-left: auto;

    @include media-md() {
      margin-bottom: 20px;
      margin-left: 0;
    }
  }

  &__group {
    display: flex;
    flex-direction: column;
    width: 50%;

    @include media-md() {
      width: 100%;
    }
  }

  &__row-body-content {
    flex-grow: 1;
    max-width: 355px;
  }

  &__list {
    margin-bottom: 15px;
  }
  //
  &__row-body-btn-block {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 5px;
  }

  &__btn {
    margin: 0 10px 10px 0;
    font-size: rem(14);

    &:last-child {
      margin-right: 0;
    }
  }

  &__row-body-bottom {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;
  }

  // row-info
  &__row-info {
    display: flex;
    flex: 0 0 100%;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    margin: 0 0 20px;
    font-size: rem(13);
    font-weight: 300;
    line-height: 24px;
    color: #6c6c6c;
    letter-spacing: 0.03em;
  }

  &__row-info-items {
    flex: 0 1 10%;
  }

  &__row-info-text {
    font-weight: 400;
    color: #000;
  }
}
</style>
